var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"p-3 bg-gray-1 h-100"},[(_vm.paymentSelected.imageUrl)?_c('div',[_c('img',{staticClass:"payment-image",attrs:{"src":_vm.paymentSelected.imageUrl,"alt":_vm.paymentSelected.imageUrl}})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }